export const PLUGIN_ID = 'neo4j-permission-elevation';
export const PERMISSION_ELEVATION_API_BASE_URL = '/permission-elevation-api';
